var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ed-movimento',{key:_vm.$root.$session.versao+'1444',attrs:{"intCabecalhoMovimentoId":0,"intMovimentoId":0,"intTipoMovimentoId":1444}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }